import React from "react";
import { connect } from "react-redux";

import { importHomeComponent } from "../../redux/actions/importActions";
import { changeForm, clearvehicleTypes } from "../../redux/actions/formActions";
import {
  createCustomer,
  fetchVehicleType,
  verifyPromotion,
  getVehicleMakes,
  checkVehiclesMake,
  getSubLocations,
  sendEmailAlert,
} from "../../redux/actions/ApiActions";
import { jumpToSteps, mapToInputPicker } from "../../tools/utils";
import { Alert } from "rsuite";
import ErrorTypes from "../../tools/ErrorTypes";
import { Helmet } from "react-helmet";
import store from "../../redux/createStore";

// vehicleTypes

class Home extends React.Component {
  homeComponentName = "";

  state = {
    homeComponentName: "",
  };

  onBooking = async () => {
    try {
      let secondPage = store
        .getState()
        .UISettings.flow.split("/")[1]
        .replace(/[_-].*/, "");

      let clientBookingURL = store.getState().UISettings.clientBookingURL ?? "";

      //await this.props.$fetchVehicleType();
      this.props.$verifyPromo().then((_) => {
        jumpToSteps(
          new URLSearchParams(window.location.search).get("clientid"),
          new URLSearchParams(window.location.search).get("lang"),
          secondPage,
          clientBookingURL
        );
      });
    } catch (err) {
      if (err === ErrorTypes.NO_VEHICLE_AVAILABLE) {
        Alert.error("No Vehicles available. Please Select different location.");
      }
      console.log(err);
    }
  };

  onVehcicleMakeChange = async () => {
    try {
      await this.props.$getMakeForVehtype();
    } catch (err) {
      if (err === ErrorTypes.NO_VEHICLE_AVAILABLE) {
        Alert.error("No Vehicles available. Please Select different location.");
      }
      console.log(err);
    }
  };

  onLocationChangeSubLoc = async () => {
    try {
      await this.props.$getSubLocations();
    } catch (err) {
      if (err === ErrorTypes.NO_LOCATION_AVAILABLE) {
        Alert.error(
          "No SubLocation available. Please Select different location."
        );
      }
      console.log(err);
    }
  };

  checkVehicleMake = async () => {
    try {
      await this.props.$CheckVehicleMake();
    } catch (err) {
      if (err === ErrorTypes.NO_VEHICLE_AVAILABLE) {
        // Alert.error('No Vehicles available.');
        throw err;
      }
      console.log(err);
    }
  };

  sendEmailAlert = async () => {
    try {
      await this.props.$sendEmailAlert();
    } catch (err) {
      if (err === ErrorTypes.NO_VEHICLE_AVAILABLE) {
        // Alert.error('No Vehicles available.');
        throw err;
      }
      console.log(err);
    }
  };

  urlParams = new URLSearchParams(window.location.search);

  componentDidMount() {
    const home = this.urlParams.get("home");

    this.setState({ homeComponentName: home });
  }

  render() {
    if (this.state.homeComponentName) {
      if (this.homeComponentName !== this.state.homeComponentName) {
        this.homeComponentName = this.state.homeComponentName;
        this.props.$importHome(this.homeComponentName);
      }
    } else if (this.homeComponentName !== this.props.homeComponentName) {
      this.homeComponentName = this.props.homeComponentName;
      this.props.$importHome();
    }
    const vehicleTypes = mapToInputPicker(
      this.props.vehicleTypes,
      "value",
      "id",
      "id"
    );
    const vehicleMakes = mapToInputPicker(
      this.props.vehicleMakes,
      "value",
      "id",
      "value"
    );

    //localStorage.removeItem('q');

    return (
      <>
        {this.props.googleTagContainerId && (
          <Helmet>
            <script>
              {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','${this.props.googleTagContainerId}');`}
            </script>
          </Helmet>
        )}
        <this.props.homeComponent
          form={this.props.form}
          locations={this.props.locations}
          primaryColor={this.props.primaryColor}
          secondaryColor={this.props.secondaryColor}
          storeHours={this.props.storeHours}
          storeHours_differentDropOff={this.props.storeHours_differentDropOff}
          storeHolidays={this.props.storeHolidays}
          dateFormat={this.props.dateFormat}
          css={this.props.css || {}}
          onBooking={this.onBooking}
          buttonColor={this.props.buttonColor}
          isAgeOnHome={this.props.isAgeOnHome}
          isReservation={true}
          vehicleTypes={vehicleTypes}
          showClock={this.props.showClock === "Y"}
          alwaysSamePickAndDrop={this.props.alwaysSamePickAndDrop}
          timeGap={this.props.timeGap}
          showPickupDropoffAddress={this.props.showPickupDropoffAddress || {}}
          hideOrDisableTimePicker={this.props.hideOrDisableTimePicker}
          minimumBookingDays={this.props.minimumBookingDays}
          maximumBookingDays={this.props.maximumBookingDays}
          minimumBookingHours={this.props.minimumBookingHours}
          earliestPickup={this.props.earliestPickup}
          minimumDriverAge={this.props.minimumDriverAge}
          $changeForm={this.props.$changeForm}
          $createCustomer={this.props.$createCustomer}
          showLogoOnHome={this.props.showLogoOnHome}
          homeScreenMessage={this.props.homeScreenMessage}
          logo={this.props.logo}
          $clearvehicleTypes={this.props.$clearvehicleTypes}
          showPromoCode={this.props.showPromoCode}
          showMonthYear={this.props.showMonthYear}
          DropDownClock={this.props.DropDownClock}
          cutOffTime={this.props.cutOffTime}
          addDaysForCheckout={this.props.addDaysForCheckout}
          homeSettings={this.props.homeSettings}
          vehicleMakes={this.props.vehicleMakes}
          onVehcicleMakeChange={this.onVehcicleMakeChange}
          minimumBookingDaysFromConfig={this.props.minimumBookingDaysFromConfig}
          checkVehicleMake={this.checkVehicleMake}
          sublocations={this.props.sublocations}
          onLocationChangeSubLoc={this.onLocationChangeSubLoc}
          sendEmailAlert={this.sendEmailAlert}
        />
      </>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    homeComponentName: store.UISettings.homeView,
    homeSettings: store.config.home,
    timeGap: store.UISettings.timeGap,
    dateFormat: store.UISettings.dateFormat,
    primaryColor: store.UISettings.primaryColor,
    secondaryColor: store.UISettings.secondaryColor,
    buttonColor: store.UISettings.buttonColor,
    isAgeOnHome: store.UISettings.isAgeOnHome,
    vehicleTypes: store.UISettings.vehicleTypes,
    showClock: store.UISettings.showClock,
    alwaysSamePickAndDrop: store.UISettings.alwaysSamePickAndDrop,
    homeComponent: store.imports.homePage,
    locations: store.locations,
    storeHours: store.storeHours,
    storeHours_differentDropOff: store.storeHours_differentDropOff,
    storeHolidays: store.storeHolidays,
    showPickupDropoffAddress: store.UISettings.showPickupDropoffAddress,
    hideOrDisableTimePicker: store.UISettings.hideOrDisableTimePicker,
    minimumBookingDays: store.UISettings.minimumBookingDays,
    maximumBookingDays: store.UISettings.maximumBookingDays,
    minimumBookingHours: store.UISettings.minimumBookingHours,
    earliestPickup: store.UISettings.earliestPickup,
    minimumDriverAge: store.UISettings.minimumDriverAge,
    form: store.form,
    css: store.imports.dynamicStyle,
    showLogoOnHome: store.UISettings.showLogoOnHome,
    homeScreenMessage: store.UISettings.homeScreenMessage,
    logo: store.UISettings.logo,
    showPromoCode: store.UISettings.showPromoCode,
    showMonthYear: store.UISettings.showMonthYear,
    DropDownClock: store.UISettings.DropDownClock,
    cutOffTime: store.UISettings.cutOffTime,
    addDaysForCheckout: store.UISettings.addDaysForCheckout,
    vehicleMakes: store.vehicleMakes,
    minimumBookingDaysFromConfig: store.UISettings.minimumBookingDaysFromConfig,
    googleTagContainerId: store.trackingSettings.googleTagContainerId,
    sublocations: store.sublocations,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    $importHome: (componentName) =>
      dispatch(importHomeComponent(componentName)),
    $changeForm: (key, value) => dispatch(changeForm(key, value)),
    $fetchVehicleType: () => dispatch(fetchVehicleType()),
    $verifyPromo: () => dispatch(verifyPromotion()),
    $createCustomer: () => dispatch(createCustomer()),
    $clearvehicleTypes: () => dispatch(clearvehicleTypes()),
    $getMakeForVehtype: () => dispatch(getVehicleMakes()),
    $CheckVehicleMake: () => dispatch(checkVehiclesMake()),
    $getSubLocations: () => dispatch(getSubLocations()),
    $sendEmailAlert: () => dispatch(sendEmailAlert()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
